import React from "react";
import { Box, Typography, Container, TextField, Button } from "@mui/material";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { tokens } from "../theme/tokens";

const ContactUs = () => (
  <>
    <Header />
    <Box
      component="main"
      sx={{
        pt: { xs: "140px", md: "120px" },
        minHeight: "72vh",
        background: `linear-gradient(145deg, rgba(10, 30, 64, 0.88) 0%, rgba(45, 106, 143, 0.55) 100%), url(https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=2000&q=80) center/cover no-repeat`,
        py: { xs: 4, md: 6 },
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            bgcolor: tokens.paper,
            borderRadius: `${tokens.radiusLg}px`,
            boxShadow: tokens.shadowLg,
            mt: { xs: 2, md: 9 },
            py: 4,
            px: { xs: 2, sm: 4 },
            border: `1px solid ${tokens.border}`,
          }}
        >
          <Typography
            variant="overline"
            sx={{ color: tokens.accent, fontWeight: 700, letterSpacing: "0.12em", display: "block", textAlign: "center" }}
          >
            Support
          </Typography>
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            sx={{
              fontFamily: tokens.fontDisplay,
              fontWeight: 700,
              color: tokens.brand,
              letterSpacing: "-0.02em",
            }}
          >
            Contact us
          </Typography>
          <Typography variant="body1" paragraph align="center" sx={{ color: tokens.textMuted }}>
            Have questions or need support? Use the form below or email{" "}
            <Box component="span" sx={{ fontWeight: 700, color: tokens.brand }}>
              info@triptripindia.com
            </Box>
            .
          </Typography>
          <Box
            sx={{
              border: `1px solid ${tokens.border}`,
              borderRadius: `${tokens.radiusMd}px`,
              p: 2,
              mb: 3,
              background: tokens.surface,
            }}
          >
            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 700, color: tokens.brand }}>
              Registered address
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, color: tokens.textMuted, fontSize: "0.9rem" }}>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Box sx={{ minWidth: 140, fontWeight: 600, color: tokens.text }}>Building / Flat</Box>
                <Box>: 1053</Box>
              </Box>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Box sx={{ minWidth: 140, fontWeight: 600, color: tokens.text }}>Road / Street</Box>
                <Box>: VIKAS NAGAR</Box>
              </Box>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Box sx={{ minWidth: 140, fontWeight: 600, color: tokens.text }}>Locality</Box>
                <Box>: Vikas Nagar</Box>
              </Box>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Box sx={{ minWidth: 140, fontWeight: 600, color: tokens.text }}>City</Box>
                <Box>: Ghaziabad</Box>
              </Box>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Box sx={{ minWidth: 140, fontWeight: 600, color: tokens.text }}>District</Box>
                <Box>: Ghaziabad</Box>
              </Box>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Box sx={{ minWidth: 140, fontWeight: 600, color: tokens.text }}>State</Box>
                <Box>: Uttar Pradesh</Box>
              </Box>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Box sx={{ minWidth: 140, fontWeight: 600, color: tokens.text }}>PIN</Box>
                <Box>: 201001</Box>
              </Box>
            </Box>
          </Box>
          <Box component="form" sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField label="Your name" variant="outlined" fullWidth required sx={{ bgcolor: tokens.surface }} />
            <TextField label="Your email" variant="outlined" fullWidth required type="email" sx={{ bgcolor: tokens.surface }} />
            <TextField
              label="Message"
              variant="outlined"
              fullWidth
              required
              multiline
              rows={4}
              sx={{ bgcolor: tokens.surface }}
            />
            <Button variant="contained" color="primary" size="large" sx={{ fontWeight: 700, mt: 1, py: 1.25 }}>
              Send message
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
    <Footer />
  </>
);

export default ContactUs;
